class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.isMegaMenu = this.mainDetailsToggle.classList.contains('mega-menu');
    this.closeTimeout = null;

    if (this.isMegaMenu && window.matchMedia('(hover: hover) and (min-width: 990px)').matches) {
      this.onMegaMenuMouseEnter = this.onMegaMenuMouseEnter.bind(this);
      this.onMegaMenuMouseLeave = this.onMegaMenuMouseLeave.bind(this);
      this.mainDetailsToggle.addEventListener('mouseenter', this.onMegaMenuMouseEnter);
      this.mainDetailsToggle.addEventListener('mouseleave', this.onMegaMenuMouseLeave);
    }
  }

  onMegaMenuMouseEnter() {
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
      this.closeTimeout = null;
    }

    this.closeSiblingMenus();

    if (!this.mainDetailsToggle.hasAttribute('open')) {
      this.mainDetailsToggle.setAttribute('open', '');
      const summary = this.mainDetailsToggle.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', true);
      this.onToggle();
    }
  }

  onMegaMenuMouseLeave() {
    this.closeTimeout = window.setTimeout(() => {
      if (!this.mainDetailsToggle.matches(':focus-within')) {
        this.close();
      }
    }, 120);
  }

  closeSiblingMenus() {
    const navigation = this.closest('.header__inline-menu');
    if (!navigation) return;

    navigation.querySelectorAll('header-menu > details.mega-menu[open]').forEach((details) => {
      if (details === this.mainDetailsToggle) return;
      details.removeAttribute('open');
      const summary = details.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', false);
    });
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  close() {
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
      this.closeTimeout = null;
    }
    super.close();
  }
}

customElements.define('header-menu', HeaderMenu);
